import Model from '@/models/Model'
import { numberFormatter } from '../../services/JSUtils'

export default class SlSaleInvoice extends Model {
    resource() {
        return 'sl_sale_invoice'
    }

    get formattedIva() {
        return '$' + numberFormatter(parseInt(this.iva))
    }

    get formattedNet() {
        return '$' + numberFormatter(parseInt(this.net_total))
    }

    get formattedTotal() {
        return (
            '$' + numberFormatter(parseInt(this.net_total) + parseInt(this.iva))
        )
    }

    get sellerName() {
        return this.first_pos_sale &&
            this.first_pos_sale.g_seller_user &&
            this.first_pos_sale.g_seller_user.hr_employee
            ? this.first_pos_sale.g_seller_user.hr_employee.name_case
            : null
    }

    get cashierName() {
        return this.first_pos_sale &&
            this.first_pos_sale.g_cashier_user &&
            this.first_pos_sale.g_cashier_user.hr_employee
            ? this.first_pos_sale.g_cashier_user.hr_employee.name_case
            : null
    }

    get customerName() {
        return this.sl_customer ? this.sl_customer.alias_name : null
    }

    get customerRut() {
        return this.sl_customer ? this.sl_customer.rut : null
    }

    get customerRutFormatted() {
        if (!this.customerRut) return null
        let rut = this.customerRut.split('-')
        rut[0] = rut[0]
            .split('')
            .reverse()
            .reduce((formatted, char, idx) => {
                if (idx && idx % 3 === 0) {
                    formatted.push('.')
                }
                formatted.push(char)
                return formatted
            }, [])
            .reverse()
            .join('')
        return rut.join('-')
    }

    get customerOfficeText() {
        return this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.address +
                  (this.sl_customer_branch_offices.city
                      ? ` - ${this.sl_customer_branch_offices.city}`
                      : '')
            : null
    }

    get branchOfficeName() {
        return this.first_pos_sale &&
            this.first_pos_sale.pos_cash_desk &&
            this.first_pos_sale.pos_cash_desk.g_branch_office
            ? this.first_pos_sale.pos_cash_desk.g_branch_office.name
            : null
    }

    get cashDeskNumber() {
        return this.first_pos_sale && this.first_pos_sale.pos_cash_desk
            ? this.first_pos_sale.pos_cash_desk.number
            : null
    }
}
